import axios, { AxiosError } from 'axios';

import { AppSignalClient } from '@/services/appSignal';

export const isAxiosError = (error?: unknown): error is AxiosError => {
  return axios.isAxiosError(error);
};

export const isZmyleError = (error?: unknown): error is ZmyleError => {
  if (!error || typeof error !== 'object') return false;

  return (
    'errorId' in error &&
    'status' in error &&
    'errorMsg' in error &&
    'occurredAt' in error
  );
};

interface CaptureExceptionParams {
  error: unknown;
  tags?: Record<string, unknown>;
}

export const captureException = (params: CaptureExceptionParams) => {
  const { error, tags } = params;

  const appSignal = AppSignalClient.getInstance();

  if (isAxiosError(error) && error.response?.data) {
    const { data = {} } = error.response as { data: Record<string, unknown> };

    const getErrorInstance = () => {
      if (isZmyleError(data)) {
        return new Error(data.errorMsg);
      }

      return new Error(error.message);
    };

    const errorInstance = getErrorInstance();

    appSignal.sendError({ error: errorInstance, payload: error, tags });

    return;
  }

  if (error instanceof Error) {
    appSignal.sendError({ error, payload: error, tags });

    return;
  }

  const errorInstance = new Error('Unknown Error');

  const payload = { error: JSON.stringify(error) };

  appSignal.sendError({ error: errorInstance, payload, tags });
};
